import React from 'react';
import numeral from 'numeral';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {observer} from 'mobx-react';

@observer
class MonthlyGivingInlineCalculator extends React.Component {
  text = () => {
    if (this.useGenericText()) {
      return t('views.inline_giving_calculator.generic_text');
    }

    return t('views.inline_giving_calculator.text', {number_of_people: this.formattedPeopleServed(), currency_unit: store.donateForm.currencyUnit, amount: this.formattedDonationAmount()});
  };

  useGenericText() {
    return isNaN(store.donateForm.amount) || store.donateForm.amount < store.donateForm.subscriptionMinAmount;
  }

  formattedDonationAmount = () => numeral(store.donateForm.amount).format('0,0.00');

  formattedPeopleServed = () => {
    const peopleServed = Math.floor(store.donateForm.amount * 12 / this.props.costPerPerson);
    return numeral(peopleServed).format('0,0');
  };

  render () {
    return (
      <span
        className="subtext"
        dangerouslySetInnerHTML={{__html: this.text()}}
      />
    );
  }
}

export default MonthlyGivingInlineCalculator;
